<template>
  <b-modal :active="value" has-modal-card @close="close()">
    <form action="">
      <div
        class="modal-card"
        style="
          min-width: 800px;
          max-width: 90%;
          min-height: 600px;
          max-height: 600px;
          overflow: auto;
        "
      >
        <!-- ヘッダ -->
        <header class="modal-card-head">
          <p
            class="modal-card-title"
            style="color: whitesmoke; text-align: left"
          >
            報告対象選択
          </p>
        </header>

        <!-- セクション -->
        <section class="modal-card-body" style="width: 100%; text-align: left">
          <!-- 医療機関テーブル -->
          <b-table
            v-if="hospitals.length > 0"
            :data="hospitals"
            default-sort-direction="asc"
            default-sort="hospitalName"
            detailed
            detail-key="hospitalName"
          >
            <template slot-scope="props">
              <b-table-column>
                <b-checkbox
                  v-model="props.row.isSelected"
                  :indeterminate="getHospitalIndeterminate(props.row)"
                  @input="updateSelectedHospital($event, props.row)"
                >
                  {{ props.row.hospitalName }}
                </b-checkbox>
              </b-table-column>
            </template>

            <template slot="detail" slot-scope="props">
              <!-- 患者テーブル -->
              <b-table
                :data="props.row.patientList"
                default-sort-direction="asc"
                default-sort="patientNameKana"
                detailed
                :opened-detailed="props.row.openedPatients"
                detail-key="patientCode"
              >
                <template slot-scope="props">
                  <b-table-column>
                    <b-checkbox
                      v-model="props.row.isSelected"
                      :indeterminate="getPatientIndeterminate(props.row)"
                      @input="updateSelectedPatient($event, props.row)"
                    >
                      {{ props.row.patientName }}
                    </b-checkbox>
                  </b-table-column>
                </template>

                <template slot="detail" slot-scope="props">
                  <!-- 対応履歴テーブル -->
                  <b-table
                    :data="props.row.historyList"
                    default-sort-direction="asc"
                    default-sort="callDate"
                  >
                    <template slot-scope="props">
                      <b-table-column>
                        <b-checkbox
                          v-model="props.row.isSelected"
                          @input="updateSelectedSupportHistory(props.row)"
                        >
                          {{ props.row.callDateTime }}
                        </b-checkbox>
                      </b-table-column>
                      <b-table-column>
                        {{ props.row.callTime }}
                      </b-table-column>
                      <b-table-column>
                        {{ props.row.categoryId | supportCategoryFilter(categories) }}
                      </b-table-column>
                    </template>
                  </b-table>
                </template>
              </b-table>
            </template>
          </b-table>

          <div v-else>
            検索条件に該当する患者履歴がありません。
          </div>
        </section>

        <!-- フッタ -->
        <footer class="modal-card-foot">
          <b-button class="button" type="button" @click="print()"
            >印刷</b-button
          >
          <b-button class="button" type="button" @click="close()"
            >閉じる</b-button
          >
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  name: "AppSupportContentsTemplate",
  props: {
    value: { type: Boolean, default: false },
    reportData: { type: Array, default: function () { return []; },
 },
  },

  methods: {
    getHospitalIndeterminate: function (hospital) {
      const selectedPatients = hospital.patientList.filter(
        (elem) => elem.isSelected
      );
      const indeterminate =
        selectedPatients.length &&
        selectedPatients.length != hospital.patientList.length
          ? true
          : false;
      return indeterminate;
    },

    getPatientIndeterminate: function (patient) {
      const selectedSupportHistories = patient.historyList.filter(
        (elem) => elem.isSelected
      );
      const indeterminate =
        selectedSupportHistories.length &&
        selectedSupportHistories.length != patient.historyList.length
          ? true
          : false;
      return indeterminate;
    },

    updateSelectedHospital: function (value, hospital) {
      // 子選択状態更新
      for (const patient of hospital.patientList) {
        patient.isSelected = value;
        this.updateSelectedPatient(value, patient);
      }

      return;
    },

    updateSelectedPatient: function (value, patient) {
      // 子選択状態更新
      for (const supportHistory of patient.historyList) {
        supportHistory.isSelected = value;
      }

      // 親選択状態更新
      const hospital = patient.hospital;
      const selectedpatients = hospital.patientList.filter(
        (elem) => elem.isSelected
      );
      hospital.isSelected = !!selectedpatients.length;

      return;
    },

    updateSelectedSupportHistory: function (supportHistory) {
      // 親選択状態更新
      const patient = supportHistory.patient;
      const selectedSupportHistories = patient.historyList.filter(
        (elem) => elem.isSelected
      );
      patient.isSelected = !!selectedSupportHistories.length;

      return;
    },

    close: function () {
      this.$emit("input", false);
      return;
    },

    print: function () {
      let hospitalList = [];
      for (const hospital of this.hospitals) {
        if (hospital.isSelected == false) {
          continue;
        }

        hospitalList.push({
          hospitalCode: hospital.hospitalCode,
          hospitalName: hospital.hospitalName,
          patientList: [],
        });

        for (const patient of hospital.patientList) {
          if (patient.isSelected == false) {
            continue;
          }

          hospitalList[hospitalList.length - 1].patientList.push({
            remarks1: patient.remarks1,
            productCode: patient.productCode,
            serialNumber: patient.serialNumber,
            patientCode: patient.patientCode,
            patientName: patient.patientName,
            patientNameKana: patient.patientNameKana,
            salseStaffCode: patient.salseStaffCode,
            salseStaffName: patient.salseStaffName,
            historyList: [],
          });

          for (const supportHistory of patient.historyList) {
            if (supportHistory.isSelected == false) {
              continue;
            }

            hospitalList[hospitalList.length - 1].patientList[hospitalList[hospitalList.length - 1].patientList.length - 1].historyList.push({
              callDateTime: supportHistory.callDateTime,
              contents: supportHistory.contents,
            });
          }
        }
      }

      this.$emit("print", hospitalList);
      this.close();
    },


    initData: function () {
      const hospitals = JSON.parse(JSON.stringify(this.reportData));
      for (const hospital of hospitals) {
        hospital.openedPatients = [];
        hospital.isSelected = true;

        for (const patient of hospital.patientList) {
          patient.hospital = hospital;
          patient.isSelected = true;
          hospital.openedPatients.push(patient.patientCode);

          for (const supportHistory of patient.historyList) {
            supportHistory.patient = patient;
            supportHistory.isSelected = true;
          }
        }
      }

      this.hospitals = hospitals;
      return;
    },
  
    getPatientSupportHistoryCategories: function (client) {
      const apiRes =
        client.apis.apiPatientSupport.getPatientSupportHistoryCategoriesGET();
      return apiRes;
    },

    getPatientSupportHistoryCategoriesSuccess: function (result) {
      this.categories = result.obj;
      return;
    },
  },

  data() {
    return {
      hospitals: [],
    };
  },

  created: async function() {
    // カテゴリ選択肢取得
    await this.apiCall(
      this.getPatientSupportHistoryCategories,
      this.getPatientSupportHistoryCategoriesSuccess,
      this.showErrorMessage
    );

    return;
  },

  watch: {
    value: function () {
      if (this.value) {
        this.initData();
      }
      return;
    },
  },

  filters: {
    supportCategoryFilter: function (value, categories) {
      let category = categories.find((elem) => elem.id == value);
      return category.categoryName;
    },
  },

  components: {},
};
</script>



// WEBPACK FOOTER //
// src/components/AppSupportReportable.vue